import { useState } from 'react'
import type { FormEvent } from 'react'
import { MicIcon } from './icons'

interface Props {
	listening: boolean
	onMicTap: () => void
	onSubmit: (text: string) => void
}

/** Layer 5 — frosted input bar: 52px mic button (green + ring pulse while
    listening) and the typed fallback. The footer never shows the number. */
export function InputBar({ listening, onMicTap, onSubmit }: Props) {
	const [value, setValue] = useState('')

	const submit = (e: FormEvent) => {
		e.preventDefault()
		const v = value.trim()
		if (!v) return
		setValue('')
		onSubmit(v)
	}

	return (
		<div className="am-inputbar">
			<div className="am-col">
				<form className="am-inputbar-row" onSubmit={submit}>
					<button
						type="button"
						className={`am-mic${listening ? ' listening' : ''}`}
						onClick={onMicTap}
						aria-label={listening ? 'Mikrofon némítása' : 'Mikrofon bekapcsolása'}
					>
						<MicIcon />
					</button>
					<input
						className="am-input"
						value={value}
						onChange={(e) => setValue(e.target.value)}
						placeholder="…vagy írjon üzenetet"
						aria-label="Üzenet írása"
					/>
				</form>
				<div className="am-inputbar-note">
					Kérdése van? Hívjon minket — koppintson fent a <b>Hívás</b> gombra
				</div>
			</div>
		</div>
	)
}
